// extracted by mini-css-extract-plugin
module.exports = {"consumptionButton":"ConsumptionButtons_consumptionButton__2064r","consumption-icon-shifted":"ConsumptionButtons_consumption-icon-shifted__2dTQ2"};